import axios from "axios";
import Swal from "sweetalert2";

export const getRequests = async (currentPage,lang) => {
  try {
    const brear = localStorage.getItem("token");

    const { data } = await axios.get(`/requests?page=${currentPage}`, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const showRequests = async (id, selectedCodeLang) => {
  try {
    const token = localStorage.getItem("token");


    const { data } = await axios.get(`/requests/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: selectedCodeLang,
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const postRequests = async (postData,lang) => {
  try {
    const brear = localStorage.getItem("token");
    const { data } = await axios.post("requests/store", postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
        "Content-type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};
export const updateRequests = async (postData, id,lang) => {
  try {
    const brear = localStorage.getItem("token");
    const { data } = await axios.post(`requests/update/${id}`, postData, {
      headers: {
        Authorization: "Bearer " + `${brear}`,
        app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
        lang: lang,
        "Content-type": "multipart/form-data",
      },
    });
    return data;
  } catch (error) {
    throw error;
  }
};

export const deleteRequests = async (id,lang) => {
  const brear = localStorage.getItem("token");
  const result = await Swal.fire({
    title: "هل انت متأكد ؟",
    text: "سيتم الحذف",
    icon: "warning",
    showCancelButton: true,
    cancelButtonColor: "#d33",
    confirmButtonText: "Okay",
  });
  if (result.isConfirmed) {
    try {
      const { data } = await axios.post(`/requests/delete/${id}`, {
        headers: {
          Authorization: "Bearer " + `${brear}`,
          app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
          lang: lang,
        },
      });
      if (data.success === true) {
        Swal.fire("Deleted!", `${data.message}`, "success");
      } else {
        Swal.fire("Not deleted", `${data.message}`, "info");
      }
      return data;
    } catch (error) {
      throw error;
    }
  }
};
export const postActiveRequests = async (postData, id) => {
  try {
    const brear = localStorage.getItem("token");
    const lang = localStorage.getItem("i18nextLng");
    const { data } = await axios.post(`requests/active/${id}`, postData, {
      Authorization: "Bearer " + `${brear}`,
      app_key: "3D3AhWezABN8DRoPO0VEtP6nq4iDBhKm35E7FlDj",
      lang,
    });
    return data;
  } catch (error) {
    throw error;
  }
};
